import { useAutoRefresh } from '@/hooks/auto-refresh';

export function AutoRefresh() {
  useAutoRefresh();
  return null;
}

AutoRefresh.displayName = 'AutoRefresh';
